import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { ToastsService } from '@app/shared/components/toasts/toasts.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private _ngZone = inject(NgZone);
  private _toastService = inject(ToastsService);

  handleError(error: Error | HttpErrorResponse) {
    this._ngZone.run(() => {
      if (error instanceof HttpErrorResponse) {
        // Server Error
        let message = 'An unknown error occurred!';
        const apiErrorResponse = error.error;

        const apiValidationErrors = apiErrorResponse?.errors
          ? (Object.values(apiErrorResponse.errors) as string[])
          : [];

        if (apiValidationErrors && apiValidationErrors.length > 0) {
          message = apiValidationErrors[0];
        } else if (apiErrorResponse && apiErrorResponse.detail) {
          message = apiErrorResponse.detail;
        } else if (!apiErrorResponse && error.status === 403) {
          message = "You don't have permission to access this resource.";
        } else if (error.message) {
          message = error.message;
        }

        this._toastService.showError(message);
      } else {
        // Client Error
        const message = error.message ? error.message : error.toString();
        this._toastService.showError(message);
      }
      console.error(error);
    });
  }
}
